<template>
      <div class="footer">
            <div style="width:1200px;margin:auto">
            <img style="width:100%" src="@/assets/bottom_imgs.png" alt="" fit="scale-down">
          </div>
        <div class="wrapper clearfix" >
          <!-- <dl>
            <dt style="color:#585454">上海迈瑞尔生化科技有限公司</dt>
            <dd><span style="color:#000">地址：</span>上海市闵行区江城路3636号</dd>
            <dd><span style="color:#000">电话：</span>400-635-6688</dd>
          </dl> -->
          <div class="serverBox clearfix">
            <dl>
              <dt style="color:#585454">购物指南</dt>
              <dd>
                <router-link target="_blank" to="/html/register">用户注册</router-link>
              </dd>
              <dd>
                <router-link target="_blank" to="/html/howorder">购物指南</router-link>
              </dd>
              <dd>
                <router-link target="_blank" to="/html/sales_provision" >销售条款</router-link>
              </dd>
              <!-- <dd>
                <router-link target="_blank" to="/bulk" >大包装询价</router-link>
              </dd> -->
            </dl>
            <dl>
              <dt style="color:#585454">支付方式</dt>
              <dd>
                <router-link target="_blank"  to="/html/pay">付款方式</router-link>
              </dd>
              <dd>
                <router-link target="_blank"  to="/html/account">账户管理</router-link>
              </dd>
              <dd>
                <router-link target="_blank"  to="/html/invoice">发票说明</router-link>
              </dd>
            </dl>
            <dl>
              <dt style="color:#585454">配送说明</dt>
              <dd>
                <router-link target="_blank"  to="/html/express">运费说明</router-link>
              </dd>
              <dd>
                <router-link target="_blank"  to="/html/send">配送说明</router-link>
              </dd>
              <dd>
                <router-link target="_blank"  to="/html/receive">外观说明</router-link>
              </dd>
            </dl>
            <dl>
              <dt style="color:#585454">帮助中心</dt>
              <dd>
                <router-link target="_blank" to="/html/customer_service" >售后服务</router-link>
              </dd>
              <dd>
                <router-link target="_blank" to="/advsearch?activeName=coa" >COA查询</router-link>
              </dd>
              <dd>
                <router-link target="_blank"  to="/forgot_password">忘记密码</router-link>
              </dd>

            </dl>
            <dl>
              <dt style="color:#585454">关于我们</dt>
              <dd>
                <router-link target="_blank" to="/html/aboutus">关于平台</router-link>
              </dd>
              <dd>
                <router-link target="_blank"  to="/html/contactus">联系我们</router-link>
              </dd>
              <dd>
                <router-link target="_blank"  to="/html/joinus">加盟平台</router-link>
              </dd>
            </dl>
          </div>
          <!-- <div>
            <img src="https://www.meryer.com/resource/images/150x150.png" alt="">
          </div> -->
        </div>
        <div class="wrapper_bottom">
            <div style="display: flex;justify-content: space-between;align-items: center;">
                <div class="left">
                    <p>所有的产品和服务只应用于科学研究，不得用于人体，我们不提供产品和服务给任何个人</p>
                    <p>未经授权禁止拷贝本站资料，如有违反，将追究法律责任</p>
                </div>
                <div calss="right">
                   <p>Copyright © 2010 by MERYER CO.,LTD <span class="hover" @click="gogov">沪ICP备14004368号-3</span></p>
                   <p style="display: flex;align-items: center;">
                    <img style="width:16px" src="https://www.meryer.com/resource/images/waba.png" alt="">
                    <span class="hover" style="margin-left: 10px;" @click="goLink">沪公网安备31011202020657号</span>
                    </p>
                   <p @click="goDanger" class="hover">危险品化学品经营许可证(不带储存设施)</p>
                </div>
            </div>
        </div>
    </div>
  </template>

  <script setup>
  function goLink(){
   let url  = 'https://beian.mps.gov.cn/#/query/webSearch'
   window.open(url,'_blank')
  }
  function goDanger(){
   let url = "https://www.meryer.com/resource/images/whpzgz.jpg"
   window.open(url,'_blank')
  }
  function gogov(){
   let url = "https://beian.miit.gov.cn/#/Integrated/index"
   window.open(url,'_blank')
  }

//   function goRegister(){
//   router.push('/login?type=register')
// }
  </script>

  <style scoped>
  .clearfix:after {
    content: "";
    height: 0;
    line-height: 0;
    display: block;
    visibility: hidden;
    clear: both;
  }

  .bottom_top {
    width: 999px;
    height: 60px;
    margin: 35px auto auto;
  }

  dt{
    font-weight: 600;
    color:#777;
    font-size: 18px;
  }

  dd {
    margin-left:0px !important;
    margin-top:12px;
    color:#585454;
    font-size: 16px;
  }

  dd a{
    text-decoration: none;
    color:#585454
  }

  .footer {
    /* background: #27394c; */
    padding: 10px 0;
    min-width: 1200px;
  }

  .wrapper {
    width: 1200px;
    margin: 0 auto;
    display: flex;
    justify-content: space-between;
    padding-top:20px;
    border-top:1px solid #ccc
  }

  .wrapper_bottom{
    width: 1200px;
    margin: 10px auto;
    color: #999;
    padding-top:10px;
    font-size: 12px;
    /* border-top: 1px solid #ccc; */
  }

  .wrapper_bottom p{
    margin: 5px 0px;
  }

.serverBox {
  display: flex;
  justify-content: space-between;
  flex: 1;
  position: relative;
}

.serverBox dl {
  display: flex;
  flex-direction: column;
  width: 100px;
  position: relative;
}

/* 中间元素等距处理 */
.serverBox dl:not(:first-child):not(:last-child) {
  margin: 0 auto;
}

/* 确保首尾元素绝对贴边 */
.serverBox dl:first-child {
  margin-right: auto;
}
.serverBox dl:last-child {
  margin-left: auto;
}

.serverBox dl:last-child {
  margin-left: auto; /* 强制最后一个元素靠右 */
}

  /* .serverBox a {
    color: #999;
  } */

  .serverBox a:hover {
    text-decoration: underline;
    color:#A52A2A
  }

  .copyRightBox {
    background: #fff;
    color: #999;
    line-height: 30px;
    text-align: center;
    min-width: 999px;
  }

  .copyRightBox a {
    color: #999;
    margin: 0 10px;
  }

  .hover:hover{
    color:#A52A2A;
    cursor: pointer;
  }

  /* .copyRightBox a:hover {
    text-decoration: underline;
  } */
  </style>
